import moment from 'moment';

export default function minBirthDate() {
  return moment('01/01/1900', 'MM/DD/YYYY').utc();
}
